import React from "react"
import Header from "./header"
import Footer from "./footer"
import PageTransition from 'gatsby-v2-plugin-page-transitions'

import "typeface-oxygen-mono"
import "./layout.scss"


const Layout = props => {
  return (
    <PageTransition>
    <div className="container">
      
        <Header></Header>

        {props.children}
    

      <Footer></Footer>
    </div>
    </PageTransition>
  )
}

export default Layout
